/**
 * Was ein Bild-Upload annimmt — spiegelt die Allowlist des Backends
 * ({@code AttachmentUploadPolicy.IMAGES}) mit allen drei Regeln: Content-Type,
 * Datei-Endung und Groesse.
 *
 * Eine Stelle, weil sonst jede Erweiterung serverseitig zwei Fundstellen im
 * Frontend braucht: Nachweise am Schrittergebnis und Bilder an Testlauf-Kommentaren
 * laden gegen dieselbe Regel hoch.
 *
 * Der {@code accept}-Hinweis allein genuegt nicht: Jeder Dateidialog laesst sich auf
 * „Alle Dateien" umstellen, und dann antwortet das Backend mit 413 oder 415, wo eine
 * verstaendliche Meldung stehen koennte.
 */
export const IMAGE_UPLOAD_TYPES: readonly string[] = ['image/png', 'image/jpeg'];

export const IMAGE_UPLOAD_EXTENSIONS: readonly string[] = ['png', 'jpg', 'jpeg'];

export const IMAGE_UPLOAD_MAX_BYTES = 1_048_576;

export const IMAGE_UPLOAD_ACCEPT = IMAGE_UPLOAD_TYPES.join(',');

/** Warum eine Datei nicht hochgeladen werden kann; {@code null} = sie darf. */
export type ImageUploadRejection = 'type' | 'size';

export function rejectImageUpload(file: File): ImageUploadRejection | null {
  const type = file.type.toLowerCase();
  const extension = extensionOf(file.name);
  if (!IMAGE_UPLOAD_TYPES.includes(type) || !IMAGE_UPLOAD_EXTENSIONS.includes(extension)) {
    return 'type';
  }
  return file.size > IMAGE_UPLOAD_MAX_BYTES ? 'size' : null;
}

function extensionOf(filename: string): string {
  const dot = filename.lastIndexOf('.');
  return dot < 0 || dot === filename.length - 1 ? '' : filename.slice(dot + 1).toLowerCase();
}
